import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { actions } from '../../../context';
import NewPluginButton from './NewPluginButton';
import PluginSearchInput from './FilterOtions/PluginSearchInput';
import FilterPluginToggles from './FilterOtions/FilterPluginToggles';
import debounce from 'lodash.debounce';
import hasPermission from '../../Shared/hasPermission';

const PluginFilterList = (props) => {
    const dispatch = useDispatch();

    const { openAddModalBehavior } = props;

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canAddEditPlugin = hasPermission(['PluginManagerEdit'], permissions);

    const [supportedPims, setSupportedPims] = useState([]);

    const updatePluginsListWithFilter = useCallback(
        (string) => dispatch(actions.missionControl.setPimsFilter(string)),
        [dispatch]
    );

    const changeHandler = (event) => {
        updatePluginsListWithFilter(event.target.value);
    };

    const debouncedChangeHandler = useMemo(
        () => debounce(changeHandler, 400),
        // eslint-disable-next-line
        []
    );

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    useEffect(() => {
        dispatch(actions.pims.getAllPims()).then((res) => {
            setSupportedPims(
                res.data.filter(
                    (p) => p.supportsConnectivity && p.name !== 'Other'
                )
            );
        });
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [dispatch, debouncedChangeHandler]);

    return (
        <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
            <Col xs="12" className="text-light">
                <div className="box box-default">
                    <div className="box-header">
                        <h3 className="box-title border-bottom border-light">
                            Search Plugins
                        </h3>
                        <div className="box-tools pull-right">
                            <button
                                type="button"
                                className="btn btn-box-tool"
                                data-widget="collapse">
                                <i className="fa fa-minus"></i>
                            </button>
                            <button
                                type="button"
                                className="btn btn-box-tool"
                                data-widget="remove">
                                <i className="fa fa-remove"></i>
                            </button>
                        </div>
                    </div>

                    <div className="box-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Search</label>
                                    <PluginSearchInput />
                                </div>
                                {canAddEditPlugin && (
                                    <div className="form-group">
                                        <div className="input-group">
                                            <NewPluginButton
                                                openAddModalBehavior={() =>
                                                    openAddModalBehavior()
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Supported PIMS</label>
                                    <div>
                                        <select
                                            name={'supportedPims'}
                                            id={'fgfghfgh'}
                                            className="form-control w-100 p-2 rounded border"
                                            onChange={(e) => {
                                                e.persist();
                                                debouncedChangeHandler(e);
                                            }}>
                                            <option value="">
                                                -- Select One --
                                            </option>
                                            {supportedPims.map((item) => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Include Inactive Plugins</label>
                                    <FilterPluginToggles />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default PluginFilterList;
